import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { searched, sorted } from "../features/jobsFilter/jobsFilterSlice";

export default function Searchbar() {
  const searchRef = useRef();
  const sortRef = useRef();
  const { type } = useSelector((state) => state.jobsFilter);
  const { sort } = useSelector((state) => state.jobsFilter);
  const dispatch = useDispatch();
  const handleSearch = (e) => {
    e.preventDefault();
    const searchedValue = searchRef.current.value;
    dispatch(searched(searchedValue));
  };
  const handleSort = () => {
    const sortsValue = sortRef.current.value;
    dispatch(sorted(sortsValue));
  };

  return (
    <>
      <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
        <h1 className="section-title">All Available {type} Jobs</h1>
        <div className="flex gap-4">
          <form onSubmit={handleSearch}>
            <div className="search-field group flex-1">
              <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
              <input
                ref={searchRef}
                type="text"
                placeholder="Search Job"
                className="search-input"
                id="lws-searchJob"
              />
            </div>
          </form>
          <select
            ref={sortRef}
            id="lws-sort"
            name="sort"
            autoComplete="sort"
            className="flex-1"
            defaultValue={sort}
            onChange={handleSort}
          >
            <option value="Default">Default</option>
            <option value="Salary (Low to High)">Salary (Low to High)</option>
            <option value="Salary (High to Low)">Salary (High to Low)</option>
          </select>
        </div>
      </div>
    </>
  );
}
